export default {
  /* -------------------------------------------------------------------------- */
  /*                             Category List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  InventoryRecords: [],
  total: 0,
  FilteredCountInventory: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Category State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Category State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,
  inventoryRecord: {}
}
